import { SamplePack } from '@arpeggi/shared'
import { theme } from '@arpeggi/ui'
import { FC } from 'react'
import { TableSkeleton } from '../../../__legacy__/components/platform/new-explore/components/Table'
import TableRow, {
  TableRowHeader
} from '../../../__legacy__/components/platform/new-explore/components/TableRow'
import Tabs from '../../../__legacy__/components/platform/new-explore/components/Tabs'
import useSelectedMedia from '../../../__legacy__/components/platform/new-explore/hooks/useSelectedMedia'
import { CurrentPageContext } from '../../verified-media'
import { useColorThief, useSPVerifiedRemixes } from '../hooks'
import { Section } from '../primitives'

export const SPVerifiedTabContent: FC<{ sp: SamplePack }> = ({ sp }) => {
  const { data, status, orderBy, order, handleOrderChange } = useSPVerifiedRemixes(sp)
  const { index, handleSelect } = useSelectedMedia({ queueData: data.map((e) => e.id) })

  const { palette } = useColorThief(sp.coverImage.url)
  const color = palette ? palette[1] : theme.colors.blackA100.value
  return (
    <CurrentPageContext.Provider value={{ samplePackId: sp?.id }}>
      <Tabs.Content value="#verified">
        <Section.Root>
          <Section.Flare1 css={{ color }} />
          <Section.Flare2 css={{ color }} />
          <Section.Content>
            <TableRowHeader order={order} orderBy={orderBy} used onSelect={handleOrderChange} />
            {status !== 'ready' && <TableSkeleton size={8} />}
            {data.map((m) => (
              <TableRow
                media={m}
                key={m.id}
                onSelect={handleSelect}
                active={m.id === index}
                used={true}
              />
            ))}
          </Section.Content>
        </Section.Root>
      </Tabs.Content>
    </CurrentPageContext.Provider>
  )
}
